import React from 'react';

const SvgIcButtonRevision = props => {
  return (
    <svg
      data-name="ic_button_revision_component"
      width={props.width || 149}
      height={props.height || 149}
      viewBox={'0 0 149 149'}
      fill={'#104EB2'}
      {...props}
    >
      <defs>
        <linearGradient
          id="ic_button_revision_svg__a"
          x2={1}
          y2={1.031}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#4DF8E0" />
          <stop offset={1} stopColor="#2A7AE2" />
        </linearGradient>
      </defs>
      <path
        d="M6 0h137a6 6 0 016 6v137a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6z"
        fill="url(#ic_button_revision_svg__a)"
      />
      <path
        data-name="Union 13"
        d="M94.634 119.045a18.71 18.71 0 1113.23 5.48 18.585 18.585 0 01-13.23-5.48zm-3.288-13.23a16.518 16.518 0 1016.518-16.518 16.537 16.537 0 00-16.518 16.518zm-1.1 12.663H29.423V35.796H52.98a7.8 7.8 0 117.643 9.36 1.56 1.56 0 110-3.12 4.68 4.68 0 10-4.393-6.24h2.833a1.56 1.56 0 110 3.12H32.542v14.04h84.241v-14.04H96.345a7.827 7.827 0 01-7.643 6.24 1.56 1.56 0 010-3.12 4.68 4.68 0 100-9.361 1.56 1.56 0 010-3.12 7.826 7.826 0 017.643 6.24h23.557v52a22.132 22.132 0 00-3.12-1.4V56.077H32.541v59.279h56.182a22.059 22.059 0 001.528 3.119zm14.55-6.66l-5.871-5.871a1.1 1.1 0 011.55-1.551l5.1 5.1 9.681-9.682a1.1 1.1 0 011.551 1.551l-10.457 10.456a1.1 1.1 0 01-1.551 0zm-45.323-21.3a13.578 13.578 0 011.752-7.355 14.319 14.319 0 001.247-11.735c-.529-1.793.4-2.694 2.222-2.254a8.6 8.6 0 014.231 2.222c.943.961 1.226.541 1.676-.4a16.457 16.457 0 016.973-7.562 5.972 5.972 0 011.876-.717c1.056-.17 1.893.381 1.693 1.463-1.039 5.649 1.852 10.035 4.5 14.516 1.609 2.724 3.413 5.321 4.1 8.528 1.924 9.031-5.294 18.227-14.482 18.324h-.178a15.385 15.385 0 01-15.61-15.035zm14.548-3.042a28.325 28.325 0 01-2.666 2.621 10.3 10.3 0 00-2.509 3.347 6.612 6.612 0 001.177 7.258 5.94 5.94 0 006.352 1.293 5.722 5.722 0 003.631-5.65c-.016-2.811-1.62-6.267-3.986-8.934-.4-.446-.7-.666-1-.666-.314-.005-.616.241-.997.726zm1.722-4.458c4.975 4.209 8.13 9.262 7.1 16.354a12.806 12.806 0 004.027-7.91c.459-3.842-1.209-6.95-3.156-10.036-2.218-3.516-4.41-7.06-5.424-11.175a11.957 11.957 0 00-.683-2.984 12.1 12.1 0 00-5.224 9c-.013.912.024 1.868-1.081 2.149-1.193.3-1.622-.6-2.047-1.476a7.917 7.917 0 00-3.01-3.669c-.024 6.118-.017 6.122-2.648 12.037a12.231 12.231 0 00-.81 7.03 8.988 8.988 0 002.232 5.031c.115-.146.229-.226.224-.3-.27-4.434 1.925-7.615 5.158-10.306a5.943 5.943 0 002.14-2.809c.349-1.157.864-1.741 1.557-1.741a2.752 2.752 0 011.644.8zm2.041-39.417a1.562 1.562 0 011.56-1.56 4.68 4.68 0 000-9.361 1.56 1.56 0 110-3.12 7.8 7.8 0 110 15.6 1.562 1.562 0 01-1.561-1.564zm-9.36 0a1.561 1.561 0 011.559-1.56 4.68 4.68 0 100-9.361 1.56 1.56 0 010-3.12 7.8 7.8 0 110 15.6 1.561 1.561 0 01-1.56-1.564z"
        fill="#fff"
      />
    </svg>
  );
};

export default SvgIcButtonRevision;
